import gql from 'graphql-tag'

// ############ Common fields ############
const optionFields = `
    id
    name
    cost
    hex
    description
    interiorListElementId
    overlaySrc
    overlaySwatchSrc
    listIndex
`

const listElementsFields = `
  id
  defaultElementListOptionId
  parentInteriorListElementId
  cost
  name
  description
  interiorId
  elementType
  listIndex
  overlaySwatchSrc
  interiorElement {
    id
    optionBlendMode
  }
  options {
    ${optionFields}
  }
`

// ############ ############ ############

// ############ Query's ############
export const GET_INTERIORS = gql`
  query activeInteriors($clientName: String!, $interior: InteriorInput!) {
    activeInteriors(clientName: $clientName, interior: $interior) {
      id
      name
      baseImageSrc
      thumbnailSrc
      disclaimer
      elementTrees {
        ${listElementsFields}
        children {
          ${listElementsFields}
          children {
            ${listElementsFields}
            children {
              ${listElementsFields}
            }
          }
        }
      }
    }
  }
`

export const GET_INTERIOR = gql`
  query getActiveInterior($clientName: String!, $interiorId: Int!) {
    activeInterior(clientName: $clientName, interiorId: $interiorId) {
      id
      name
      thumbnailSrc
      baseImageSrc
      disclaimer
      elementTrees {
        ${listElementsFields}
        children {
          ${listElementsFields}
          children {
            ${listElementsFields}
            children {
              ${listElementsFields}
            }
          }
        }
      }
    }
  }
`

export const ALL_CLIENT_INTERIORS = gql`
  query activeInteriors($clientName: String!) {
    activeInteriors(clientName: $clientName) {
      id
      name
      baseImageSrc
      thumbnailSrc
      disclaimer
      interiorAssignments {
        id
        interiorId
        communityId
        planId
        elevationId
      }
      elementTrees {
        ${listElementsFields}
        children {
          ${listElementsFields}
          children {
            ${listElementsFields}
            children {
              ${listElementsFields}
            }
          }
        }
      }
    }
  }
`

export const COMMUNITY_INTERIORS_WITH_OPTIONS = gql`
  query interiors($clientName: String!, $interior: InteriorInput!) {
    interiors(clientName: $clientName, interior: $interior) {
      id
      name
      baseImageSrc
      disclaimer
      interiorAssignments {
        id
        interiorId
        communityId
        planId
        elevationId
      }
      elementTrees {
        ${listElementsFields}
        children {
          ${listElementsFields}
          children {
            ${listElementsFields}
            children {
              ${listElementsFields}
            }
          }
        }
      }
    }
  }
`

export const GET_INTERIOR_PRESETS = gql`
  query getPreset($clientName: String!, $interiorId: Int!) {
    interiorPresets(clientName: $clientName, interiorId: $interiorId) {
      id
      name
      interiorId
      description
      interiorPresetAssignments {
        interiorListElement {
          id
          name
          cost
          interiorId
          listIndex
          parentInteriorListElementId
          elementType
          overlaySwatchSrc
        }
        interiorElementOption {
          ${optionFields}
        }
      }
    }
  }
`

export const GET_INTERIOR_ALTERNATES = gql`
  query getInteriorAlternates($clientName: String!, $interiorId: Int!) {
    interiorElementOptionAlternateGroups(
      clientName: $clientName
      interiorId: $interiorId
    ) {
      optionAlternates {
        cost
        primaryOption {
          id
        }
        memberOption {
          id
        }
      }
    }
  }
`
